import { createSlice } from "@reduxjs/toolkit";

export const servicePackage = createSlice({
  name: "servicePackage",
  initialState: {
    value: false,
  },
  reducers: {
    setServicePackage: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setServicePackage } = servicePackage.actions;
export default servicePackage.reducer;
